import { render, staticRenderFns } from "./processDetail.vue?vue&type=template&id=57c5066b&scoped=true&"
import script from "./processDetail.vue?vue&type=script&lang=js&"
export * from "./processDetail.vue?vue&type=script&lang=js&"
import style0 from "./processDetail.vue?vue&type=style&index=0&id=57c5066b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c5066b",
  null
  
)

export default component.exports